import React, { Fragment } from 'react';
import PropTypes from 'prop-types';


const PolicyVersionNavigation = ({
  id,
  createdAt,
  version,
  isCurrent,
  onClickLink,
}) => (
  <li className="PolicyVersionNavigation__item">
    {isCurrent ? (
      `Version ${version}. Last modified: ${createdAt}`
    ) : (
      <Fragment>
        Click
        {' '}
        <a
          href={`#${id}`}
          onClick={onClickLink}
        >
          here
        </a>
        {' '}
        {`for version ${version}. Last modified: ${createdAt}`}
      </Fragment>
    )}
  </li>
);

PolicyVersionNavigation.propTypes = {
  id: PropTypes.number.isRequired,
  createdAt: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
  isCurrent: PropTypes.bool.isRequired,
  onClickLink: PropTypes.func.isRequired,
};

export default PolicyVersionNavigation;
